import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Cluster } from 'ol/source'
import { Style, Icon, Circle, Fill, Stroke, Text, } from 'ol/style.js';
import CircleStyle from 'ol/style/Circle';
import ApiService from 'services/ApiService';
import { ToFeatures } from 'services/GeoJsonService';

export default class LayerFacilitySurf extends VectorLayer {

    constructor(map) {
        let clusterStyle = function (feature) {
            let size = feature.get('features').length;
            if (size > 1) {
                // Clustered point (multiple features)
                return [
                    new Style({
                        image: new Icon({
                            anchor: [0.5, 0.5],
                            anchorXUnits: 'fraction',
                            anchorYUnits: 'fraction',
                            // src: '/images/facility/surf_active.png',
                            src: '/images/facility/clust_surf_bg.svg',
                        }),
                        // text: new Text({
                        //     font: 'bold 36px Noto Sans KR, sans-serif',
                        //     text: size.toString(),
                        //     textBaseline: "alphabetic",
                        //     padding: [-8, 4, -8, 4], // [top, right, bottom, left]
                        //     backgroundFill: new Fill({
                        //         color: '#fff',
                        //     }),
                        //     backgroundStroke: new Stroke({
                        //         color: '#000',
                        //         width: 2
                        //     }),
                        //     fill: new Fill({
                        //         color: '#000'
                        //     }),
                        //     stroke: new Stroke({
                        //         color: '#fff',
                        //         width: 2
                        //     }),
                        // }),
                        zIndex: 1
                    }),
                    new Style({
                        // image: new CircleStyle({
                        //     radius: 20, // 원 크기 조정 
                        //     fill: new Fill({
                        //         color: 'rgba(255,126 ,234, 0.8)' // 투명 배경 
                        //     }),
                        //     displacement: [0, 13], // [x, y] 형태로 위치 조정, y에 음수 값을 주면 위로 이동
                        // }),
                        text: new Text({
                            font: 'bold 32px Pretendard, sans-serif', // 32px 
                            text: size.toString(),
                            textBaseline: "middle",
                            textAlign: "center",
                            position: "relative",
                            offsetY: 0, // 텍스트 위치 조정 

                            fill: new Fill({
                                color: '#333'
                            })
                        }),
                        zIndex: 1
                    })
                ]
            }
            // else {
            //     // Single feature (unclustered)
            //     feature = feature.get('features')[0];
            //     const stat = feature.getProperties()?.properties.stat;
            //     return new Style({
            //         image: new Icon({
            //             anchor: [0.5, 0.5],
            //             anchorXUnits: 'fraction',
            //             anchorYUnits: 'fraction',
            //             src: stat == 1 ? '/images/facility/surf_active.png' : '/images/facility/surf_inactive.png',
            //         }),
            //         zIndex: 1
            //     })
            // }
            else {
                // Single feature (unclustered)
                feature = feature.get('features')[0];
                const stat = feature.getProperties()?.properties.stat;
                const roadStat = feature.getProperties()?.properties.roadStat;

                let iconSrc = '';

                if (stat == 1) {
                    if (roadStat === "001") {
                        iconSrc = '/images/facility/surf_active.png';
                    } else if (roadStat === "003") {
                        iconSrc = '/images/facility/surf_wet.png';  // wet 아이콘 경로
                    } else if (roadStat === "006") {
                        iconSrc = '/images/facility/surf_ice.png';  // ice 아이콘 경로
                    } else if (roadStat ==="009") {
                        iconSrc = '/images/facility/surf_inactive.png'; //에러
                    }
                } else {
                    iconSrc = '/images/facility/surf_inactive.png';
                }

                return new Style({
                    image: new Icon({
                        anchor: [0.5, 0.5],
                        anchorXUnits: 'fraction',
                        anchorYUnits: 'fraction',
                        src: iconSrc,
                    }),
                    zIndex: 1
                })
            }
        };

        super({
            name: 'surfLayer',
            source: new Cluster({
                distance: 120,
                minDistance: 80,
                source: new VectorSource(),
            }),
            visible: true,
            style: clusterStyle,
            userLayer: true,
            layerIndex: 3,
        });
        this.map = map;
        this.map?.addLayer(this);
        this.setData();
    }

    setData = function () {
        const layer = this;
        ApiService.get("newdashboard/gis/GetRoad").then(response => {
            if (response.status === 200) {
                const data = response.data;

                let dataset = new Array();
                let id, name, x, y, stat, obj;
                for (let i = 0; i < data.rows.length; i++) {

                    id = data.rows[i]['roadId'];
                    name = data.rows[i]['roadNm'];
                    x = data.rows[i]['x'];
                    y = data.rows[i]['y'];
                    stat = data.rows[i]['stat'];
                    const roadStat = data.rows[i]['roadStat']; // roadStat 추가

                    obj = { id: id, x: x, y: y, nm: name, stat: stat, type: "surf", roadStat: roadStat };
                    dataset.push(obj);
                }

                let source = this.getSource()
                if (source instanceof Cluster) {
                    source = source.getSource();
                    source.addFeatures(ToFeatures(dataset))
                } else if (source instanceof VectorSource) {
                    source.addFeatures(ToFeatures(dataset))
                }
            }
        })
    }
}